// PL
export const calendarsChatbotHc = {
  monthlyCalendar: {
    pricesTitle: "Ceny dynamiczne",
    prices: "Ceny",
    noPropertiesAvailable: "Brak dostępnych obiektów",
    noPropertiesFound: "Nie znaleziono obiektów",
    minStayShort: "min. {n}n",
    available: "Dostępne",
    closed: "Zamknięte",
    loading: "Wczytywanie…",
    showMoreMonths: "Pokaż więcej miesięcy",
    from: "Od",
    to: "Do",
    nightsLabelOne: "{n} noc",
    nightsLabelMany: "{n} nocy",
    whatToDo: "Co należy zrobić?",
    close: "Zamknij",
    open: "Otwórz",
    price: "Cena",
    minStay: "Min. pobyt",
    closeReasonPlaceholder: "Powód zamknięcia (opcjonalnie)",
    openHint: "Wybrane terminy zostaną ponownie otwarte (blokada zostanie usunięta).",
    nightsWord: "nocy",
    clearSelection: "Wyczyść zaznaczenie",
    past: "Przeszłość",
    guestOne: "gość",
    guestMany: "gości",
    perNight: "/ noc",
    noName: "Bez nazwy",
    channelDirect: "Bezpośrednia",
    ownerBlockComment: "Blokada właściciela",
    prepTime: "Czas przygotowania",
    sameDayCutoff: "Godzina graniczna tego samego dnia",
    linkedClosed: "Cały apartament",
    linkedClosedInfo: "Zamknięte przez regułę całego apartamentu ({motivo}). Otworzy się samo, jeśli ta rezerwacja zostanie anulowana lub zmienią się jej daty.",
    alsoLinked: "również zamknięte przez regułę całego apartamentu ({motivo})",
    applyClose: "Zamknij terminy",
    applyOpen: "Otwórz terminy",
    applyPrice: "Zapisz cenę",
    applyMinStay: "Zapisz minimalny pobyt",
    apply: "Zastosuj",
    processing: "Przetwarzanie…",
    closingDates: "Zamykanie terminów…",
    openingDates: "Otwieranie terminów…",
    priceModeLabel: "Tryb ceny",
    priceModeFixed: "Stała",
    priceModePercent: "%",
    priceModeAmount: "Kwota",
    percentPlaceholder: "np. 20",
    amountPlaceholder: "np. 10",
    percentHint: "Każda noc przeliczana od własnej ceny. Ze znakiem − obniża.",
    amountHint: "Dodaje się do obecnej ceny każdej nocy. Ze znakiem − obniża.",
    invalidPrice: "Należy podać prawidłową cenę.",
    changingPrice: "Zmiana ceny za noc…",
    priceUpdated: "Cena została zaktualizowana.",
    priceUpdateError: "Nie udało się zaktualizować ceny.",
    minStayMin: "Minimalny pobyt musi wynosić co najmniej 1 noc.",
    changingMinStay: "Zmiana minimalnego pobytu…",
    minStayUpdated: "Minimalny pobyt został zaktualizowany.",
    minStayUpdateError: "Nie udało się zaktualizować minimalnego pobytu.",
    unknownError: "Nieznany błąd",
  },
  calendar: {
    channelDirect: "Bezpośrednia",
    searchMin2: "Należy wpisać co najmniej 2 znaki, aby wyszukać",
    searchNoResults: "Nie znaleziono rezerwacji dla tego wyszukiwania",
    searchError: "Błąd podczas wyszukiwania rezerwacji",
    processing: "Przetwarzanie…",
    ownerBlockComment: "Blokada właściciela",
    cutoffTip: "Godzina graniczna sprzedaży tego samego dnia: {time}",
    nightsLabelOne: "{n} noc",
    nightsLabelMany: "{n} nocy",
    turnoverBefore: "Czas przygotowania: blokada {nights} przed każdym check-in",
    turnoverAfter: "Czas przygotowania: blokada {nights} od każdego check-out",
    turnoverBoth: "Czas przygotowania: blokada {nights} przed check-in i od check-out",
    selectAtLeastOneProperty: "Należy wybrać co najmniej jeden obiekt.",
    selectAtLeastOneDate: "Należy wybrać co najmniej jedną datę obowiązywania, aby zastosować zmiany.",
    preparingOps: "Przygotowywanie operacji: {total}...",
    applyingOps: "Stosowanie {index} z {total}: {name}",
    unknownError: "Nieznany błąd",
    couldNotSaveChanges: "Nie udało się zapisać zmian.",
    bulkApplyError: "Nie udało się zastosować zmian masowych. {message}",
    opsApplied: "Zastosowano {success} z {total} operacji.",
    opsSkipped: "Pominięto {skipped} terminów z potwierdzonymi rezerwacjami.",
    opsFailed: "Nieudane operacje: {failed}.",
    bulkApplied: "Edycja masowa zastosowana w {count} obiektach.",
    couldNotOpenDate: "Nie udało się otworzyć terminu",
    datesOpened: "Terminy zostały otwarte",
    closeUpdated: "Blokada została zaktualizowana",
    todayLabel: "Dzisiaj",
    closed: "Zamknięte",
    linkedClosed: "Cały apartament",
    linkedClosedInfo: "Zamknięte przez regułę całego apartamentu ({motivo}). Otworzy się samo, jeśli ta rezerwacja zostanie anulowana lub zmienią się jej daty.",
    alsoLinked: "również zamknięte przez regułę całego apartamentu ({motivo})",
    closingDates: "Zamykanie terminów…",
    couldNotCloseDates: "Nie udało się zamknąć terminów",
    clearFiltersTitle: "Wyczyść filtry",
    noPropertiesAvailable: "Brak dostępnych obiektów",
    noPropertiesFound: "Nie znaleziono obiektów",
    dynamicPricesTitle: "Ceny dynamiczne",
    prices: "Ceny",
    viewWide: "Widok szeroki",
    viewCompact: "Widok kompaktowy",
    viewNormal: "Widok normalny",
    viewFull: "Widok pełny",
    searchBookingTitle: "Szukaj rezerwacji",
    searchBookingPlaceholder: "Szukaj rezerwacji…",
    search: "Szukaj",
    resultsSelectOne: "Wyniki: {count}, proszę wybrać jeden:",
    bulkEdit: "Edycja masowa",
    goToTodayTitle: "Przejdź do dzisiaj",
    showHeader: "Pokaż nagłówek",
    configArrivalDeparture: "Skonfiguruj reguły przyjazdu i wyjazdu",
    notAvailable: "Niedostępne",
    extension: "Przedłużenie",
    lateCheckoutUntil: "Późne wyjście do {time}",
    aiRequests: "Recepcja AI",
    guestComments: "Uwagi gościa",
    internalNotes: "Notatki wewnętrzne",
    extrasTitle: "Wykupione dodatki",
    extrasPending: "Oczekuje na potwierdzenie",
    reqArrivalTitle: "Godzina przyjazdu",
    reqAt: "o {time}",
    reqUntil: "do {time}",
    reqNights: "Dodatkowe noce: {n}",
    reqPending: "Oczekuje",
    reqConfirmed: "Potwierdzona",
    reqPaid: "Opłacona",
    reqOffered: "Zaproponowana",
    reqPrioritised: "Priorytetowa",
    pendingAmount: "Do zapłaty:",
    noticesColumn: "Powiadomienia",
    callsTitle: "Połączenia",
    callsCount: "Połączenia: {n}",
    extensionPaid: "Przedłużenie opłacone",
    listCheckin: "Przyjazd",
    listCheckout: "Wyjazd",
    priceOriginal: "Rezerwacja pierwotna",
    priceExtension: "Przedłużenie",
    priceTotal: "Razem",
    paymentInProcess: "Płatność w toku",
    overbooking: "Overbooking",
    noAccommodationsFound: `Nie znaleziono obiektów pasujących do "{term}".`,
    past: "Przeszłość",
    paymentInProcessLower: "płatność w toku",
    pendingApproval: "oczekuje na zatwierdzenie",
    pendingApprovalTitle: "Oczekuje na zatwierdzenie",
    guestOne: "gość",
    guestMany: "gości",
    perNight: "/ noc",
  },
  tableFilters: {
    filterByDate: "Filtruj po dacie od - do",
    filterByCountry: "Filtruj po kraju",
    all: "Wszystkie",
    countrySpain: "Hiszpania",
    countryColombia: "Kolumbia",
    countryBrazil: "Brazylia",
    filterByState: "Filtruj po statusie",
    allStates: "Wszystkie statusy",
    stateDemo: "Wersja demo",
    stateSubscribed: "Subskrypcja aktywna",
    stateNotSubscribed: "Bez subskrypcji",
    searchRecords: "Przeszukaj rekordy",
  },
  chatbotPageIndex: {
    aiAgentBadge: "Agent AI",
    planFeatureHint: "Funkcja dostępna w płatnym planie.",
    otaAgentTitle: "Agent AI dla OTA",
    otaAgentHint: "Po włączeniu agent automatycznie odpowiada na wiadomości z Booking, Airbnb i innych OTA.",
    otaRequiresWhatsapp: "Wymaga aktywnego agenta AI na WhatsApp.",
    guardNotice: "Przy wyłączonym agencie AI czat również automatycznie przechodzi w tryb <strong>odpowiedzi ręcznej</strong>. Przełączniki poszczególnych rozmów pozostaną zablokowane do czasu ponownego włączenia agenta.",
    configureBasic: "Skonfiguruj podstawowego agenta AI",
    configureAdvanced: "Skonfiguruj zaawansowanego agenta AI",
    comingSoon: "Wkrótce",
    detailFallback: "Szczegóły",
    errorLoadListingConfig: "Nie udało się wczytać konfiguracji oferty",
    errorSaveChange: "Błąd podczas zapisywania zmiany",
    otaAgentActivated: "Agent AI dla OTA został aktywowany",
    otaAgentDeactivated: "Agent AI dla OTA został dezaktywowany",
  },
  chatbotIndex: {
    accommodationFallback: "Obiekt",
    defaultHandoffSupportLine: "\nW razie potrzeby szybkiej pomocy prosimy o kontakt pod numerem {phone} 📞",
    defaultHandoffMessage: "Dzień dobry 😊 W tej chwili nie mam tej informacji, ale ktoś z naszego zespołu wkrótce pomoże 🙌{suffix}\nJesteśmy do dyspozycji przez cały pobyt! 🏡✨",
    silentModeMessage: "Do gościa nie zostanie wysłana żadna automatyczna odpowiedź. System nadal będzie powiadamiał operatora, aby mógł kontynuować rozmowę.",
    statusNoGuestReply: "Brak odpowiedzi do gościa",
    statusUsingCustom: "Używana wiadomość własna",
    statusUsingDefault: "Używana wiadomość domyślna",
    helperSilent: "Gość nie otrzyma automatycznej odpowiedzi, gdy agent AI nie zna odpowiedzi, ale operator dostanie powiadomienie, aby przejąć rozmowę.",
    helperCustom: "System automatycznie przetłumaczy tę wiadomość własną na język gościa.",
    helperHasCustom: "Wiadomość własna jest zapisana, ale w tej chwili system nadal będzie używał wiadomości domyślnej.",
    helperDefault: "Po utworzeniu wiadomości głównej można ją tutaj włączyć, a system automatycznie przetłumaczy ją na język gościa.",
    sourceSilent: "Cisza",
    sourceCustom: "Własna",
    sourceDefault: "Domyślna",
    defaultBotName: "Mój wirtualny asystent",
    errorLoadBotName: "Nie udało się wczytać nazwy asystenta.",
    errorLoadHandoff: "Nie udało się wczytać wiadomości przekazania rozmowy.",
    botNameUpdated: "Nazwa asystenta została zaktualizowana.",
    errorSaveBotName: "Nie udało się zapisać nazwy asystenta.",
    masterMessageUpdated: "Wiadomość główna została zaktualizowana.",
    errorSaveMaster: "Nie udało się zapisać wiadomości głównej.",
    warnCreateCustomFirst: "Najpierw należy utworzyć wiadomość własną, aby ją włączyć.",
    modeCustomActivated: "Od teraz będzie używana wiadomość własna.",
    modeSilentActivated: "Bot zachowa ciszę, gdy nie będzie znał odpowiedzi, ale operator nadal otrzyma powiadomienie.",
    modeDefaultActivated: "Od teraz będzie używana wiadomość domyślna.",
    errorUpdateActiveMessage: "Nie udało się zaktualizować aktywnej wiadomości.",
    warnWriteQuestion: "Przed zapisaniem należy wpisać pytanie.",
    questionCreated: "Pytanie zostało utworzone.",
    errorAddQuestion: "Nie udało się dodać pytania.",
    botNamePlaceholder: "Nazwa asystenta",
    handoffRowTitle: "Wiadomość, gdy agent nie zna odpowiedzi",
    customize: "Dostosuj",
    expandAria: "Rozwiń",
    handoffSubtitle: "Ten tekst zostanie wysłany, gdy agent AI nie znajdzie odpowiedzi w faktach, pamięci ani w pytaniach i odpowiedziach.",
    modeDefaultTitle: "Wiadomość domyślna",
    modeDefaultDesc: "Standardowa wiadomość systemowa z numerem telefonu do pomocy.",
    modeCustomTitle: "Wiadomość własna",
    modeCustomDescActive: "Włącza tekst własny zapisany w oknie edycji.",
    modeCustomDescEmpty: "Nie utworzono jeszcze wiadomości własnej.",
    modeSilentTitle: "Nie odpowiadaj gościowi",
    modeSilentDesc: "Gość nie otrzymuje automatycznej wiadomości, ale operator dostanie powiadomienie, aby kontynuować rozmowę.",
    loadingMessage: "Wczytywanie wiadomości...",
    masterMessage: "Wiadomość główna",
    newQuestionTitle: "Nowe pytanie",
    newQuestionSubtitle: "Utwórz nowe często zadawane pytanie, aby agent AI odpowiadał trafniej.",
    guestQuestionLabel: "Pytanie gościa",
    questionPlaceholder: "np. O której godzinie jest check-in?",
    questionHelp: "Wskazówka: warto zapisać pytanie tak, jak zadałby je prawdziwy gość.",
    cancel: "Anuluj",
    saveQuestion: "Zapisz pytanie",
    handoffKicker: "Odpowiedź przy przekazaniu rozmowy",
    handoffModalTitle: "Dostosuj wiadomość główną",
    handoffModalSubtitle: "Wystarczy napisać jedną wiadomość po hiszpańsku. System przetłumaczy ją automatycznie i odpowie w języku, którym posługuje się gość.",
    masterToolbarInfo: "Można używać emotikon i przyjaznego tonu, tak jak w pozostałych wiadomościach automatycznych.",
    emojiSearchPlaceholder: "Szukaj emoji...",
    masterTextareaPlaceholder: "Tutaj należy wpisać wiadomość główną. Można używać emotikon i ciepłego tonu wobec gościa.",
    masterHint: "Zalecenie: wiadomość warto napisać po hiszpańsku, dokładnie w takim tonie, jaki ma zostać przekazany. System automatycznie dostosuje ją do języka gościa.",
    viewDefaultMessage: "Zobacz wiadomość domyślną",
    saveMessage: "Zapisz wiadomość",
    newButton: "Nowe",
    emojiButton: "Emoji",
  },
  messageAccountDemo: {
    usingDemo: "Korzystanie z wersji demo",
    ofThePlatform: "platformy",
    trialHave: "Pozostało jeszcze",
    trialDaysToEnjoy: "dni na korzystanie ze wszystkich funkcji!",
    trialSubscribeNow: "Warto wykupić subskrypcję teraz i zarządzać obiektami bez przerw.",
    subscribeNowLabel: "Wykup subskrypcję",
  },
};
